export const Album = [
    {
        title: "Mumbai",
        subtitle: "Maharashtra, India",
        description: "See full forecast",
        image:
            "https://media-cdn.tripadvisor.com/media/attractions-splice-spp-674x446/06/6a/c4/f0.jpg",
        link: "#",
    },
    {
        title: "Kedarnath",
        subtitle: "Uttarakhand, India",
        description: "Watch more videos like this",
        image:
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/19/a8/9a/0a/photo9jpg.jpg?w=1100&h=-1&s=1",
        link: "#",
    },
    {
        title: "Jaipur",
        subtitle: "Rajasthan, India",
        description: "Learn about the event",
        image:
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/17/d3/a8/57/images-30-largejpg.jpg?w=700&h=400&s=1",
        link: "#",
    },
    {
        title: "Patna",
        subtitle: "Bihar, India",
        description: "See more traffic updates",
        image:
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/04/a3/3b/42/nalanda.jpg?w=1200&h=-1&s=1",
        link: "#",
    },
    {
        title: "Srinagar",
        subtitle: "Kashmir, India",
        description: "Watch more videos like this",
        image:
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/05/41/be/c4/beautiful.jpg?w=1200&h=-1&s=1",
        link: "#",
    },
    {
        title: "Bhopal",
        subtitle: "Madhya Pradesh, India",
        description: "Watch more videos like this",
        image:
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/04/54/a9/df/upper-lake.jpg?w=1800&h=1000&s=1",
        link: "#",
    },
    {
        title: "Mysure",
        subtitle: "Tamil Nadu, India",
        description: "Watch more videos like this",
        image:
            "https://media-cdn.tripadvisor.com/media/attractions-splice-spp-674x446/07/74/91/39.jpg",
        link: "#",
    },
    {
        title: "Jolly Buoy Island",
        subtitle: "Kerala, India",
        description: "Watch more videos like this",
        image:
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/06/47/95/02/jolly-buoy-island.jpg?w=1000&h=600&s=1",
        link: "#",
    },
    {
        title: "Mussoorie ",
        subtitle: "Uttarakhand, India",
        description: "Watch more videos like this",
        image:
            "https://media-cdn.tripadvisor.com/media/attractions-splice-spp-674x446/0a/ba/fa/34.jpg",
        link: "#",
    },
    {
        title: "Kedarkantha",
        subtitle: "Uttarakhand, India",
        description: "Watch more videos like this",
        image:
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/27/aa/d8/cc/the-mighty-mountains.jpg?w=1400&h=-1&s=1",
        link: "#",
    },
    {
        title: "Spiti Valley",
        subtitle: "Himachal Pradesh, India",
        description: "Watch more videos like this",
        image:
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0f/d8/62/4c/dhankar-lake.jpg?w=1800&h=1000&s=1",
        link: "#",
    },
    {
        title: "Benaulim Beach",
        subtitle: "Goa, India",
        description: "Watch more videos like this",
        image:
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/15/66/b5/10/benaulim-beach.jpg?w=1400&h=800&s=1",
        link: "#",
    },
    {
        title: "Jaiselmer",
        subtitle: "Rajasthan, India",
        description: "Watch more videos like this",
        image:
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0e/0b/ad/0d/fort-rajwada.jpg?w=2000&h=-1&s=1",
        link: "#",
    },
    {
        title: "Nainital Lake",
        subtitle: "Uttarakhand, India",
        description: "Watch more videos like this",
        image:
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0f/2e/b4/5d/nainital-lake.jpg?w=1800&h=1000&s=1",
        link: "#",
    },
    {
        title: "Coorg",
        subtitle: "Karnataka, India",
        description: "Watch more videos like this",
        image:
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/15/4d/47/10/kodagu-coorg.jpg?w=1200&h=900&s=1",
        link: "#",
    },
    {
        title: "Sonamorg",
        subtitle: "Kashmir, India",
        description: "Watch more videos like this",
        image:
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/22/37/53/49/sonamorg-kashmir.jpg?w=1100&h=-1&s=1",
        link: "#",
    },
    {
        title: "Darjeeling",
        subtitle: "West Bengal, India",
        description: "Watch more videos like this",
        image:
            "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/12/df/eb/ac/goechala-trek.jpg?w=1600&h=-1&s=1",
        link: "#",
    },
    {
        title: "Gulmarg",
        subtitle: "Kashmir, India",
        description: "Watch more videos like this",
        image:
            "https://media-cdn.tripadvisor.com/media/attractions-splice-spp-674x446/06/75/90/b1.jpg",
        link: "#",
    },
];